import { render, staticRenderFns } from "./VdoLiveSetTopicEdit.vue?vue&type=template&id=8fc066a2&scoped=true&"
import script from "./VdoLiveSetTopicEdit.vue?vue&type=script&lang=js&"
export * from "./VdoLiveSetTopicEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc066a2",
  null
  
)

export default component.exports